import { jwtDecode } from "jwt-decode";
import { store, read } from "./LocalStorage";

export const initUser = (data) => {
  store("token", data.token);
  store("main-local", data.id);
  store("local", data.user);
}

export const readToken = () => {
  return read("token");
}

export const storeToken = (token) => {
  store("token", token);
}

export const removeLocalStorage = () => {
  localStorage.clear();
}

export const analyzer = (token) => {
  if(token) {
    try {
      let decoded = jwtDecode(token);
      if(decoded.rate && decoded.scale && decoded.submiter && decoded.access) {
        // store("local", decoded.user_id);
        store("access", JSON.parse(atob(decoded.access)));
        return true;
      } else {
        return false;
      }
    } catch {
      return false;
    }
  } else {
    localStorage.clear();
    return false;
  }
};